.node {
    position: relative;
    /* Off-screen rows skip style and layout work; a row is 32px tall. */
    content-visibility: auto;
    contain-intrinsic-size: auto 32px;

    &::before {
        position: absolute;
        z-index: 1;
        left: calc(var(--label-offset) - 10.5px);
        top: 0;
        content: '';
        width: 1px;
        height: 100%;
        background-color: var(--mantine-color-ldGray-1);
    }
}

.label {
    position: relative;

    &:where([data-selected]) {
        background-color: transparent !important;
    }
}
